export default __webpack_public_path__ + "static/mailchimp-ac3d4b79d5b56a166ae387ccb78a52f2.svg";